(function () {
  'use strict';

  angular.module('app').component('bankList', bankList());

  function bankList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
      },
      controller: BankListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/banks/bank-list/bank-list.component.html',
    };
  }

  BankListComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'AbilityService', 'BankService'];

  function BankListComponent(config, UtilService, AbilityService, BankService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_bank_accountadmin'),
      canUpdate: AbilityService.can('update_bank_accountadmin'),
      canDestroy: AbilityService.can('destroy_bank_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.productTypes = config.ALL_PRODUCT_TYPES;

    vm.filterCriteria = BankService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    // vm.onUpdateItems    = onUpdateItems;

    function fetchResult() {
      vm.loadingItems = true;

      vm.filterCriteria = BankService.getFilterCriteria();
      BankService.getBanks(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = BankService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }
      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      BankService.deleteBank(item, fetchResult);
    }

    function changeItemStatus(item) {
      BankService.changeBankStatus(item);
    }

    /*function onUpdateItems(action) {
            var successCallback = function(){
                vm.showActions = false;
                vm.selectedAll = false;

                if (action === 'destroy'){
                    fetchResult();
                }
            };

            BankService.updateBanks(action, vm.items, successCallback);
        }*/
  }
})();
